// react
import { useContext, useState } from 'react';

// types
import { DocumentType } from '../../../@types';

// i18n
import { useTranslation } from 'react-i18next';

// context
import { ContextUserEntity } from '../../../App.context';

// fields
import { Select, SelectProps } from '../Select/Select';

// hooks
import { useFetch } from '../../../hooks/useFetch';

export const SelectDocumentType = ({ ...props }: SelectProps) => {
	// session
	const accessToken = sessionStorage.getItem('accessToken');
	const idToken = sessionStorage.getItem('idToken');

	// hooks
	const { t } = useTranslation();

	// state
	const [documentTypes, setDocumentTypes] = useState<DocumentType[]>([]);

	// context
	const { userEntity } = useContext(ContextUserEntity);

	// define document types URL
	let urlDocumentTypes = `${process.env.REACT_APP_API_URL}/document-types`;
	if (userEntity) {
		urlDocumentTypes += `?entity=${userEntity.id},null`;
	}

	// fetch document types
	const { isLoading } = useFetch({
		url: urlDocumentTypes,
		options: {
			headers: {
				Authorization: `Bearer ${accessToken}`,
				User: String(idToken),
			},
		},
		onSuccess: (res) => {
			if (res.data) {
				setDocumentTypes(res.data);
			}
		},
	});

	// options
	const options = documentTypes
		.map((documentType) => {
			return {
				label: documentType.name,
				value: String(documentType.id),
			};
		})
		.sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase() ? 1 : -1));

	return <Select disabled={isLoading} label={t('type')} name="type" options={options} {...props} />;
};
